import Vue from 'vue'
import { baseDataService, reorder } from './mixins/itemDataServiceMixins'

export default new (Vue.extend({
	defaultPath: '/team/links/templates',
	mixins: [baseDataService, reorder],
}))()
